import React from 'react';
import { connect } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import CalendarioIcon from '../../assets/calendar-icon.svg';
import LocalIcon from '../../assets/location-icon.svg';
import SearchIcon from '../../assets/search-gray-icon.png';
import ActivityIcon from '../../assets/activity-icon.svg';
import PublicIcon from '../../assets/public-icon.svg';


import './Input.css';

const colourStyles = {
  control: (base, state) => ({
    ...base,
    position: 'relative',
    height: '60px',
    paddingLeft: '25px',
    boxShadow: state.isFocused ? 0 : 0,
    borderRadius: 0,
    borderColor: state.isFocused
      ? '#000'
      : base.borderColor,
    '&:hover': {
      borderColor: state.isFocused
        ? '#000'
        : base.borderColor,
    },
  }),
  input: (base) => ({
    ...base,
    marginLeft: '20px',
  }),
  option: (styles, {
    isDisabled, isFocused,
  }) => ({
    ...styles,
    borderRadius: 0,
    backgroundColor: isFocused ? '#000' : 'white',
    color: isFocused ? 'white' : '#000',
    cursor: isDisabled ? 'not-allowed' : 'default',

  }),
  menu: (base) => ({
    ...base,
    width: '100%',
    marginTop: '0',
    borderRadius: 0,
    zIndex: 15,

  }),
  placeholder: (base) => ({
    ...base,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '95%',
    textAlign: 'left',
    marginLeft: '20px',
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: 'none',
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isSelected ? '#000' : 'gray',
    marginLeft: '20px',
  }),
};

function InputSelect(props) {
  let icon = CalendarioIcon;
  if (props.icon === 'locationIcon') {
    icon = LocalIcon;
  } else if (props.icon === 'activityIcon') {
    icon = ActivityIcon;
  } else if (props.icon === 'publicIcon') {
    icon = PublicIcon;
  } else if (props.icon === 'searchIcon') {
    icon = SearchIcon;
  }

  let defaultValue;
  if (props.name === 'oaName') {
    defaultValue = { label: props.oaName, value: props.oaName };
  } else if (props.name === 'userType') {
    [defaultValue] = props.publicType;
  } else if (props.name === 'activityType') {
    [defaultValue] = props.activityType;
  }

  return (
    <div className="position-relative">
      <img className="input-icon" src={icon} alt="ícone" />
      {props.creatable ? (
        <>
          <CreatableSelect
            styles={colourStyles}
            className={props.className ? `${props.className} react-select-container` : 'react-select-container'}
            name={props.name ? props.name : 'inputSelect'}
            options={props.options}
            onChange={props.onChange}
            placeholder={props.placeholder}
            formatCreateLabel={(val) => `Pesquise por: "${val}"`}
            noOptionsMessage={() => 'Nenhum resultado encontrado'}
            value={defaultValue.value !== '' ? defaultValue : ''}
            createOptionPosition="first"
            allowCreateWhileLoading="true"
            theme={(theme) => ({
              ...theme,
              borderRadius: 0,
              border: '1px solid',
              colors: {
                ...theme.colors,
                primary25: '#F7F7F7',
                primary50: '#DFDFDF',
                primary: '#000101',
              },
            })}
          />
        </>
      )
        : (
          <>
            <Select

              styles={colourStyles}
              className={props.className ? `${props.className} react-select-container` : 'react-select-container'}
              name={props.name ? props.name : 'inputSelect'}
              options={props.options}
              onChange={props.onChange}
              placeholder={props.placeholder}
              formatCreateLabel={(val) => `Pesquise por: ${val}`}
              noOptionsMessage={() => 'Nenhum resultado encontrado'}
              value={defaultValue || ''}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                border: '1px solid',
                colors: {
                  ...theme.colors,
                  primary25: '#F7F7F7',
                  primary50: '#DFDFDF',
                  primary: '#000101',
                },
              })}
            />
          </>
        )}
    </div>
  );
}

const mapStateToProps = (store) => ({
  oaName: store.filterState.oaName,
  publicType: store.filterState.oaPublicType,
  activityType: store.filterState.oaActivityType,
});
export default connect(mapStateToProps)(InputSelect);
